<div class="top-container">
  <div class="filter-controls">
    <fi-search
      [class.compact-view]="true"
      [isMobile]="isMobile"
      [value]="filters.search"
      (searchChanged)="queryChanged.emit($event)"
      (mobileSearchClicked)="openMobileFilters('search')"
    ></fi-search>

    @if (!isMobile) {
      <div class="category-field">
        <div class="field-label" fiTranslation="SEARCH_CATEGORY"></div>
        <div fiCustomSelect
          (value)="setCategoriesValue($event)"
          [data]="categoryTypes"
          [displaySelectionValue]="selectedCategoryKey"
          [placeHolder]="categoryPlaceHolder"
          [dataValueKey]="'categoryKey'"
          [dataNameKey]="'categoryName'"
          [class.invalid]="false"
          class="select-type select input-field">
          <span class="selected-value placeholder"></span>
          <img src="assets/icons/arrow-up.svg" alt="icon" class="arrow">
          <div class="options-cont">
            <ul class="options"></ul>
          </div>
        </div>
      </div>
    }

    @if (!isMobile) {
      <div class="date-field">
        <div class="field-label" fiTranslation="REQUEST_OVERVIEW_FILTER_CREATED_ON"></div>
        <fi-date-filter (dateRangeSelected)="rangeSelected.emit($event)"
          [rangeDisplayFormat]="'short'"
          [showSelectedRange]="true"
        [range]="[filters.fromDate, filters.toDate]"></fi-date-filter>
      </div>
    }
  </div>

  @if (!isMobile) {
    <div class="toggle-container">
      <div class="toggle-btn_cont">
        <fi-checkbox class="toggle-btn" (checkedChange)="onFilterChanged()"
          [(ngModel)]="filters.onlyMyLeads">
          <span class="toggle-text" fiTranslation="REQUEST_OVERVIEW_FILTER_MY_REQUESTS"></span>
        </fi-checkbox>
      </div>
      <div class="toggle-btn_cont">
        <fi-checkbox class="toggle-btn" (checkedChange)="onFilterChanged()"
          [(ngModel)]="filters.openLeads">
          <span class="toggle-text" fiTranslation="REQUEST_OVERVIEW_FILTER_OPEN_REQUESTS"></span>
        </fi-checkbox>
      </div>
      <div class="toggle-btn_cont">
        <fi-checkbox class="toggle-btn" (checkedChange)="onFilterChanged()"
          [(ngModel)]="filters.closedLeads">
          <span class="toggle-text" fiTranslation="REQUEST_OVERVIEW_FILTER_COMPLETED_REQUESTS"></span>
        </fi-checkbox>
      </div>
      <div class="toggle-btn_cont">
        <fi-checkbox class="toggle-btn" (checkedChange)="onFilterChanged()"
          [(ngModel)]="filters.unreadLeads">
          <span class="toggle-text" fiTranslation="REQUEST_OVERVIEW_FILTER_UNREAD_REQUESTS"></span>
        </fi-checkbox>
      </div>
    </div>
  }

  @if (!isMobile) {
    <div class="view-switches">
      <button class="compact-view-switch"
        [class.active]="compactView$ | async"
        (click)="compactViewToggle.emit(true)">
        <img src="assets/icons/compact-view-enabled.svg" alt="" #compactView [isTitle] = "true" fiTranslation="REQUEST_OVERVIEW_DANCE_VIEW_TOOLTIP" matTooltip="{{compactView.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
      </button>
      <button class="compact-view-switch"
        [class.active]="!(compactView$ | async)"
        (click)="compactViewToggle.emit(false)">
        <img src="assets/icons/compact-view-disabled.svg" alt="" #normalView [isTitle] = "true" fiTranslation="REQUEST_OVERVIEW_NORMAL_VIEW_TOOLTIP" matTooltip="{{normalView.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
      </button>
    </div>
  }

  @if (isMobile) {
    <button class="filter-btn" (click)="openMobileFilters()">
      <img src="/assets/icons/filters.svg" alt="Filters">
      <span class="u-hidden-visually" fiTranslation="ALT_TEXT_REQUEST_OVERVIEW_FILTER"></span>
    </button>
  }
</div>

@if (isMobile && showFiltersOnMobile) {
  <fi-requests-overview-mobile-filter-overlay
    [filters]="filters"
    [isFinstralUser]="isFinstralUser"
    [categoryTypes]="categoryTypes"
    [initialSection]="mobileFilterInitialSection"
    (closed)="setShowFiltersOnMobile(false)"
    (filtersChanged)="filtersChanged.emit()"
    (queryChanged)="queryChanged.emit($event)"
    (categoryTypeChanged)="categoryTypeChanged.emit($event)"
    (rangeSelected)="rangeSelected.emit($event)"
    (sortChanged)="sortChanged.emit($event)"
  ></fi-requests-overview-mobile-filter-overlay>
}
